import React from 'react';
import Button from 'Components/UI/Button';
import history from 'State/history';
import { useBalanceSheetPageURL } from 'Hooks/useBalanceSheetPageURL';

const AccountAggregatorModalButton = () => {
  const balanceSheetPageURL = useBalanceSheetPageURL();
  return <Button onClick={() => history.push(balanceSheetPageURL)} variant="contained" color="primary">Edit Accounts</Button>;
};

AccountAggregatorModalButton.propTypes = {
};

AccountAggregatorModalButton.defaultProps = {

};

export { AccountAggregatorModalButton };

export default AccountAggregatorModalButton;
